import { stripCpfDigits } from '@/Pages/Signup/utils/cpfMask';
import type { SignupFormData } from '@/types/signup';

const BRAZIL_NATIONALITY = 'BR';

function collapseWhitespace(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

export function normalizeSignupFormData(form: SignupFormData): SignupFormData {
  const nationality = form.nationality.trim().toUpperCase();
  const document = nationality === BRAZIL_NATIONALITY
    ? stripCpfDigits(form.document)
    : collapseWhitespace(form.document);
  return {
    fullName: collapseWhitespace(form.fullName),
    email: form.email.trim().toLowerCase(),
    birthDate: form.birthDate.trim(),
    nationality,
    document,
  };
}
